import React, { ReactNode } from 'react';

import Snackbar from 'components/DesignSystem/Snackbar';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import { SectionState } from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

export default function PreferencesSection<T extends { id: number }>({
  preferences, renderRow, open, onToggle,
}: SectionState & {
  preferences: T[];
  renderRow: (preference: T) => ReactNode;
}) {
  return (
    <Section label="Preferências salvas" open={open} onToggle={onToggle}>
      {preferences.length === 0 && (
        <Snackbar className="mt-2">Nenhuma preferência disponível.</Snackbar>
      )}
      {preferences.map((preference) => (
        <React.Fragment key={preference.id}>{renderRow(preference)}</React.Fragment>
      ))}
    </Section>
  );
}
